import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../../../components/layout"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import Link from "../../../components/Link"

const KlausPage = props => {
    const {
        breadcrumb: { crumbs },
    } = props.pageContext
    var customCrumbLabel = props.location.pathname
        .replace("-", " ")
        .replace(/.*\//g, "")
    return (
        <Layout location={props.location}>
            <Helmet>
                <html className="memberpage" lang="da" />
            </Helmet>
            <div className="content-wide">
                <div className="wide-container">
                    <div className="wide-inner">
                        <Breadcrumb
                            crumbs={crumbs}
                            crumbSeparator=" / "
                            crumbLabel={customCrumbLabel}
                        />
                    </div>
                </div>
            </div>
            <div className="content-wide">
                <div className="wide-container">
                    <div className="wide-inner">
                        <div className="space-8"></div>

                        <div className="grid">
                            <div className="member-2col-left">
                                <div className="member-inner">
                                    <h1>Klaus Veng</h1>
                                    <h3>Professional</h3>
                                    <div
                                        class="table-container"
                                        role="table"
                                        aria-label="Destinations"
                                    >
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Date of employment at Emento
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Dec. 2015 is Emento founded and the first real day at the office was 14 jan 2016
                                            </div>
                                        </div>
                                        <div class="flex-table row" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Title
                                            </div>
                                            <div class="flex-row" role="cell">
                                                COO and Co-founder
                                            </div>
                                        </div>
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Responsibilities
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Products and development
                                            </div>
                                        </div>
                                        <div class="flex-table row" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Educational background
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Firefighter, Nurse, Degree in Health Science and Research, Master IT and Organizations
                                            </div>
                                        </div>
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Previous positions/industries
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Product Designer of Clinical Logistics IT Solution at Cetrea (now Getinge), Project Manager of Innovation at Aarhus University Hospital and Board member at MedTech Innovation Consortium
                                            </div>
                                        </div>
                                    </div>
                                    <h3>Personal</h3>
                                    <div
                                        class="table-container"
                                        role="table"
                                        aria-label="Destinations"
                                    >
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Bucket list no. 1
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Trip to Japan and/or driving across Canada in a Camper Van
                                            </div>
                                        </div>
                                        <div class="flex-table row" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Favorite music
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Pop-Rock
                                            </div>
                                        </div>
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Biggest food or drink consumption
                                            </div>
                                            <div class="flex-row" role="cell">
                                                I once ate seven plates of Mongolian barbecue
                                            </div>
                                        </div>
                                        <div class="flex-table row" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Best TV series
                                            </div>
                                            <div class="flex-row" role="cell">
                                                The Knick
                                            </div>
                                        </div>
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Extraordinary skill
                                            </div>
                                            <div class="flex-row" role="cell">
                                                To cope with very little sleep without going insane
                                            </div>
                                        </div>
                                        <div class="flex-table row" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Preferred traveling style
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Going to new places with only little planned ahead
                                            </div>
                                        </div>
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                My friends recognizes me for
                                            </div>
                                            <div class="flex-row" role="cell">
                                                Friendly, helpful and calm
                                            </div>
                                        </div>
                                        <div class="flex-table row" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                As a kid, I wanted to become
                                            </div>
                                            <div class="flex-row" role="cell">
                                                A firefighter or captain of a giant cargo ship (Maersk)
                                            </div>
                                        </div>
                                        <div class="flex-table row alt" role="rowgroup">
                                            <div class="flex-row first" role="cell">
                                                Social links
                                            </div>
                                            <div class="flex-row" role="cell">
                                                <Link to="www.linkedin.com/in/klausveng/" target="_blank" rel="noreferrer">
                                                    LinkedIn
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="member-2col-middle">
                                <div className="member-hero-inner">
                                    <div className="member-hero-box">
                                        <div className="member-hero-image">
                                            <img
                                                src="/images/portraits/internal/klaus_hero.jpg"
                                                alt=""
                                            />
                                        </div>
                                        <h3>Feels like: Obi-Wan Kenobi</h3>
                                        Strength
                                        <div className="full-bar">
                                            <div className="bar size-80" />
                                        </div>
                                        Artistic
                                        <div className="full-bar">
                                            <div className="bar size-50" />
                                        </div>
                                        Spontaneous
                                        <div className="full-bar">
                                            <div className="bar size-70" />
                                        </div>
                                        Determined
                                        <div className="full-bar">
                                            <div className="bar size-70" />
                                        </div>
                                        Polite
                                        <div className="full-bar">
                                            <div className="bar size-90" />
                                        </div>
                                        Playful
                                        <div className="full-bar">
                                            <div className="bar size-70" />
                                        </div>
                                        Empathy
                                        <div className="full-bar">
                                            <div className="bar size-90" />
                                        </div>
                                        Intelligence
                                        <div className="full-bar">
                                            <div className="bar size-80" />
                                        </div>
                                        Brave
                                        <div className="full-bar">
                                            <div className="bar size-80" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="member-2col-right">
                                <div className="member-childhood-inner">
                                    <div
                                        className="member-childhood-image"
                                        style={{
                                            backgroundImage: `url(/images/portraits/internal/klaus_child.jpg)`,
                                        }}
                                    >
                                        <div className="blur-bg">
                                            <img
                                                src="/images/portraits/internal/klaus_child.jpg"
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default KlausPage
